<div class="alternative-verification-report">
  <!-- Render IDV Report if IDV data is available -->
  <div v-if="has_idv_data">
    <IdVerificationReport :id_liveness_data="idv_data" :customer_image="customer_image" />
  </div>

  <!-- Render OCR Liveness Report if OCR data is available but no IDV data -->
  <div v-else-if="has_ocr_data">
    <OcrLivenessVerificationReport :ocr_liveness_data="ocr_liveness_data" />
  </div>

  <!-- Fallback if no verification data is available -->
  <div v-else>
    <PageComponent>
      <SectionSheet>
        <div
          class="container-fluid py-3 header d-flex align-items-center justify-content-between border-bottom mb-3"
        >
          <div class="d-flex">
            <img
              class="logo"
              width="295"
              height="125"
              src="@/assets/images/new_black_logo2.svg"
              alt="Logo"
            />
          </div>
          <div class="d-flex text-end">
            <div>
              <div class="h4 fw-bold mb-1">
                Alternative Liveness Verification
              </div>
              <div class="text-muted text-xs">
                28 Fricker Rd,<br />
                Illovo, Johannesburg,<br />
                2196 South Africa<br />
                Website:
                <a
                  href="https://www.goodpeopledata.com/"
                  target="_blank"
                  class="text-decoration-none text-muted"
                  >www.goodpeopledata.com</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm border bg-white mb-2">
          <div class="card-header">
            <h6 class="mb-0">Alternative Liveness Verification</h6>
          </div>
            <div class="card-body text-center text-xs">
              <div class="alert d-flex flex-column align-items-center justify-content-center mb-0 bg-white" role="alert">
              <i class="bi bi-exclamation-triangle-fill text-warning mb-2" style="font-size: 2rem;"></i>
              <span class="text-center">
                <strong>No Data Available:</strong>
                <br>
                There is currently no data for this service. Please check back later or contact support for assistance.
              </span>
              </div>
            </div>
        </div>
        <div class="report-meta">
          <div><span class="text-muted">Ref:</span> {{ report_id }}</div>
          <div>
            <span class="text-muted">Generated:</span> {{ generated_date }}
          </div>
        </div>
      </SectionSheet>
    </PageComponent>
  </div>
</div>
